import styles from "./select.module.css";

import { forwardRef, type SelectHTMLAttributes } from "react";

export interface SelectProps
  extends Omit<SelectHTMLAttributes<HTMLSelectElement>, "onChange"> {
  onChange?: (value: string) => void;
  options: { label: string; value: string }[];
  placeholder?: string;
  value?: string;
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ className, onChange, options, placeholder, value, ...props }, ref) => {
    return (
      <select
        ref={ref}
        value={value}
        className={`${styles.select} ${className}`}
        onChange={(e) => onChange?.(e.target.value)}
        {...props}
      >
        {placeholder && <option value="">{placeholder}</option>}
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    );
  }
);

Select.displayName = "Select";
